import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=f976a650&scoped=true"
import script from "./organizationList.vue?vue&type=script&lang=js"
export * from "./organizationList.vue?vue&type=script&lang=js"
import style0 from "./organizationList.vue?vue&type=style&index=0&id=f976a650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f976a650",
  null
  
)

export default component.exports